import { Box, Button, Fade, Grid, Typography } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import { TextFieldSaurus } from "components/inputs/text-field-saurus"
import { DinheiroIcon } from "components/icons/dinheiro-icon"
import { useStyles } from "./informar-pagamento-dinheiro-styles"
import { OkIcon } from "utils/Icons/ok-icon"
import { SemDinheiroIcon } from "components/icons/sem-dinheiro-icon"
import { toDecimal } from "utils/to-decimal"
import { useThemeQueries } from "components/dialogs/dialog-adicionar-produto-com-subitem/util-styles"
import { toInteger } from "lodash"

export type InformarPagamentoDinheiroProps = {
    onSubmit: (valor: number) => void
    valorPedido: number
}

export const InformarPagamentoDinheiro = ({ onSubmit, valorPedido }: InformarPagamentoDinheiroProps) => {
    const classes = useStyles()
    const { theme, isMobile } = useThemeQueries()

    const [valor, setValor] = useState('')
    const [erro, setErro] = useState('')

    const [viewportHeight, setViewportHeight] = useState<number | string>(typeof window !== 'undefined' ? window?.visualViewport?.height ? toInteger(window?.visualViewport?.height) + 20 + 'px' : '100%' : 0)

    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window?.visualViewport?.height ? toInteger(window?.visualViewport?.height) + 20 + 'px' : '100%')
        }
        window.addEventListener('resize', handleResize)
        const vv: any = (window as any).visualViewport
        const handleVV = () => {
            if (vv?.height) setViewportHeight(vv.height)
        }
        if (vv) vv.addEventListener('resize', handleVV)
        return () => {
            window.removeEventListener('resize', handleResize)
            if (vv) vv.removeEventListener('resize', handleVV)
        }
    }, [])

    return (
        <Fade in>
            <Box
                component="form"
                onSubmit={(e) => {
                    e.preventDefault()
                    const valorInformado = toDecimal(valor)
                    if (valorInformado < valorPedido) {
                        setErro('O valor informado é menor que o valor do pedido')
                        return
                    }
                    onSubmit(toDecimal(valor))
                }}
                p={2}
                display="flex"
                alignItems="center"
                flexDirection="column"
                height={"100%"}
                maxHeight={`calc(${viewportHeight}px - 60px)`}
                minHeight="300px"
            >
                <Box
                    flex="1 1 auto"
                    textAlign="center"
                    display='flex'
                    flexDirection="column"
                    justifyContent={!isMobile ? "center" : 'flex-start'}
                >
                    {!isMobile && (
                        <Box>
                            <Box display="flex" justifyContent="center">
                                <DinheiroIcon
                                    tipo={
                                        theme.palette.type === "light"
                                            ? 'BUTTON'
                                            : 'BUTTON_PRIMARY'
                                    }
                                    style={{
                                        height: 50,
                                        width: 50
                                    }} />
                            </Box>
                        </Box>
                    )}
                    <Box>
                        <Typography variant="h5" style={{
                            fontWeight: 700
                        }}>
                            Precisa de troco?
                        </Typography>
                    </Box>
                    <Box mb={1}>
                        <Typography align="center">
                            Informe o valor que pagará em dinheiro para calcular o troco
                        </Typography>
                    </Box>
                    <Box>
                        <TextFieldSaurus
                            className={classes.input}
                            helperText={erro}
                            error={Boolean(erro)}
                            tipo="DECIMAL"
                            variant="outlined"
                            allowSubmit
                            color="primary"
                            manterMascara
                            value={valor as unknown as string}
                            onChange={(ev) => setValor(ev.target.value)}
                            size="medium"
                        />
                    </Box>
                    <Box>
                        <Typography align="center">
                            O valor do pedido é de {' '}
                            <Box component="span" fontWeight={700} fontSize={20}>
                                {toDecimal(valorPedido).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </Box>
                        </Typography>
                    </Box>
                </Box>
                <Box width="100%">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth type="submit" size="large">
                                <OkIcon tipo="BUTTON_PRIMARY" />
                                Confirmar
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" color="primary" fullWidth type="button" size="large" onClick={() => onSubmit(valorPedido)}>
                                <SemDinheiroIcon tipo="BUTTON" />
                                Não quero troco
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Fade>
    )
}
